import NsContent from 'components/common/ns-content/NsContent';
import { useDispatch } from 'react-redux';

import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { useSupplyStatus } from 'hooks/useSupplyStatus';
import { useNavigation } from 'hooks/useNavigation';
import { setGas, setElectric } from 'state/fuel-type/fuel-type-slice';

export const testId = 'splitSupplyTestId';

export const SplitSupply = () => {
  const dispatch = useDispatch();
  const { isNewToBrandForElec } = useSupplyStatus();
  const moveInFuel = !isNewToBrandForElec ? 'electricity' : 'gas';
  const acquisitionFuel = isNewToBrandForElec ? 'electricity' : 'gas';
  const { next, eventTypes } = useNavigation();

  const handleGoNext = () => {
    if (!isNewToBrandForElec) {
      dispatch(setElectric());
    } else {
      dispatch(setGas());
    }
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title="Dual fuel energy – why it could be better for you" />
        <h3>We currently only supply {moveInFuel} to your new home.</h3>

        <p>
          Having both fuels with a single supplier makes it’s quicker and easier
          to manage your energy account as everything is in <b>one place</b> and
          any queries can be sorted by <b>one contact</b>.
        </p>
        <p>
          Once you’ve completed your move we’ll show you how to get a new quote
          to transfer your {acquisitionFuel} over to us.
        </p>
        <NsPrimaryCta onClick={handleGoNext}>
          Continue with your move
        </NsPrimaryCta>
      </NsContent>
    </NsPanel>
  );
};

export default SplitSupply;
